import * as React from 'react';
import * as Moment from 'moment-timezone';
import * as Utils from '../Utils';
import { isWorkdayCalculationSupported, calculateWorkdays } from './specialDays';

interface IStatTableProps {
  firstDate: Date;
  firstTz: string;
  secondDate: Date;
  secondTz: string;
}

interface IDiff {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

export const NUM_FORMAT = new Intl.NumberFormat('en-US');

function calculateDiff(from: Moment.Moment, to: Moment.Moment): IDiff {
  const act = from.clone();
  const year = to.diff(act, 'years');
  act.add(year, 'years');
  const month = to.diff(act, 'months');
  act.add(month, 'months');
  const day = to.diff(act, 'days');
  act.add(day, 'days');
  const hour = to.diff(act, 'hours');
  act.add(hour, 'hour');
  const minute = to.diff(act, 'minutes');
  return {
    year,
    month,
    day,
    hour,
    minute
  }
}

export default function StatTable(props: IStatTableProps) {
  const from = Moment(props.firstDate).tz(props.firstTz);
  const to = Moment(props.secondDate).tz(props.secondTz);
  const diff = calculateDiff(from, to);
  const diffMinutes = to.diff(from, "minutes");
  const middleTime = from.clone();
  middleTime.add(diffMinutes / 2, "minutes");
  middleTime.locale("hu");
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th scope="col" colSpan={2}>Difference</th>
            <th scope="col" className="text-right">Cumulative</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Year:</th>
            <td className="text-right">{diff.year}</td>
            <td className="text-right">{NUM_FORMAT.format(to.diff(from, 'years'))}</td>
          </tr>
          <tr>
            <th scope="row">Month:</th>
            <td className="text-right">{diff.month}</td>
            <td className="text-right">{NUM_FORMAT.format(to.diff(from, 'months'))}</td>
          </tr>
          <tr>
            <th scope="row">Day:</th>
            <td className="text-right">{diff.day}</td>
            <td className="text-right">{NUM_FORMAT.format(to.diff(from, 'days'))}</td>
          </tr>
          {isWorkdayCalculationSupported(from, to) ?
            <tr>
              <th scope="row">Working day:</th>
              <td className="text-right">-</td>
              <td className="text-right">{NUM_FORMAT.format(calculateWorkdays(from, to))}</td>
            </tr>
            : null
          }
          <tr>
            <th scope="row">Hour:</th>
            <td className="text-right">{diff.hour}</td>
            <td className="text-right">{NUM_FORMAT.format(to.diff(from, 'hours'))}</td>
          </tr>
          <tr>
            <th scope="row">Minute:</th>
            <td className="text-right">{diff.minute}</td>
            <td className="text-right">{NUM_FORMAT.format(to.diff(from, 'minutes'))}</td>
          </tr>
        </tbody>
      </table>
      <table className="table">
        <tbody>
          <tr>
            <th scope="row">Middle time:</th>
            <td className="text-right">{middleTime.format(Utils.DATE_FORMAT + ' ' + Utils.TIME_FORMAT)}</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}


// WEBPACK FOOTER //
// ./src/Calculator/StatTable.tsx